import axios from 'axios';
import * as CONFIG from '../config/index';
export const EMPLOYEE_API_URL = `${CONFIG.API_URL}/employee`
export const search = async function (props) {
  let searchProps = {
    account: props.account ? props.account : '',
    roleCode: props.roleCode ? props.roleCode : '',
    notInRole: props.notInRole ? props.notInRole : '',
    email: props.email ? props.email : '',
    pageNo: props.pageNo ? props.pageNo : CONFIG.DEFAULT_PAGE_START,
    pageSize: props.pageSize ? props.pageSize : CONFIG.DEFAULT_PAGE_SIZE
  }
  let res = await axios.get(`${EMPLOYEE_API_URL}/search?account=${searchProps.account}&roleCode=${searchProps.roleCode}&notInRole=${searchProps.notInRole}&email=${searchProps.email}&pageNo=${searchProps.pageNo}&pageSize=${searchProps.pageSize}`);
  return res.data.data;
}

export default {
  sync: {
    search: search
  }
}



// WEBPACK FOOTER //
// ./src/common/employee.js